import React from 'react'
import ClientSuspense from '@components/ClientSuspense'

import usePreferencesCleaner from '../hooks/usePreferencesCleaner'

function PreferencesCleanerInner() {
  usePreferencesCleaner()

  return null
}

export default function PreferencesCleaner() {
  return (
    <ClientSuspense fallback={null}>
      <PreferencesCleanerInner />
    </ClientSuspense>
  )
}
